import React from "react";
import { Alert, Button } from "reactstrap";
import { TecAssuredStore } from "../../../../../../stores/TecAssuredStore";

class TecAssuredErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error("TecAssured Error Boundary caught an error:", error, errorInfo);
	}

	handleReset = () => {
		// Get reset function from store
		const { reset } = TecAssuredStore.getState();
		reset();

		// Reset error boundary state
		this.setState({ hasError: false, error: null });
	};

	render() {
		if (this.state.hasError) {
			return (
				<Alert color="danger">
					<h4 className="alert-heading">Something went wrong</h4>
					<p>
						{this.state.error?.message || "An unexpected error occurred while processing your request."}
					</p>
					<hr />
					<div className="d-flex gap-2">
						<Button color="primary" onClick={this.handleReset}>
							Start Over
						</Button>
					</div>
				</Alert>
			);
		}

		return this.props.children;
	}
}

export default TecAssuredErrorBoundary;
